import { render, staticRenderFns } from "./platformPage.vue?vue&type=template&id=4d30bbaa&scoped=true"
import script from "./platformPage.vue?vue&type=script&lang=js"
export * from "./platformPage.vue?vue&type=script&lang=js"
import style0 from "./platformPage.vue?vue&type=style&index=0&id=4d30bbaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d30bbaa",
  null
  
)

export default component.exports